import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from '@mui/material/Typography';
import Logo from '../../images/login-header-logo.svg';
import '../Main/main.scss';
import CustomMenu from '../Menu/Menu';
import { getCompanyId } from "../../Utils/Common";

const Header = ({ handleChange }) => {
    const [companyId, setCompanyId] = useState('');
    let usrCompanyId = getCompanyId();
    // setCompanyId(usrCompanyId);
    const handleCompanyId = event => {
        setCompanyId(event.target.value);
    };

    const handleSetCompanyId = event => {
        // pass value from header to layout component
        handleChange(event.target.value);
    };
    
    return (

        <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, bgcolor: "#3B3F4A" }}>
            <Toolbar>
                <img alt='logo' src={Logo} style={{ 'height': '31px', width: '283.43px' }} />
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                </Typography>
                <div className="toolbar-right-panel"><label for="companyId"> Company ID
                    <input
                        type="search"
                        id="companyId"
                        name="companyId"
                        onChange={handleCompanyId}
                        onBlur={handleSetCompanyId}
                        value={usrCompanyId === 0 ? companyId : usrCompanyId}
                        readOnly={usrCompanyId === 0 ? false : true}
                    /></label>

                    <CustomMenu color={'orange'}/>
                </div>
            </Toolbar>
        </AppBar>

    );
};

export default Header;